/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Image_ReplaceInputs */

const vi_shop_image_replace = /** @type {(inputs: Shop_Image_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đổi ảnh`)
};

/**

* @param {Shop_Image_ReplaceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_image_replace = /** @type {((inputs?: Shop_Image_ReplaceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Image_ReplaceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_image_replace(inputs)
});